import { render, staticRenderFns } from "./Followers.vue?vue&type=template&id=be886926&scoped=true"
import script from "./Followers.vue?vue&type=script&lang=js"
export * from "./Followers.vue?vue&type=script&lang=js"
import style0 from "./Followers.vue?vue&type=style&index=0&id=be886926&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be886926",
  null
  
)

export default component.exports